import { Bed, Bath, Tv, Wifi, Car } from "lucide-react";
import RoomDetail from "./RoomDetail";
import familyNew1 from "@/assets/family-new-1.jpeg";
import familyNew2 from "@/assets/family-new-2.jpeg";
import familyNew3 from "@/assets/family-new-3.jpeg";
import familyNew4 from "@/assets/family-new-4.jpeg";
import familyNew5 from "@/assets/family-new-5.jpeg";
import familyNew6 from "@/assets/family-new-6.jpeg";
import familyNew7 from "@/assets/family-new-7.jpeg";
import familyNew8 from "@/assets/family-new-8.jpeg";
import familyNew9 from "@/assets/family-new-9.jpeg";
import familyNew10 from "@/assets/family-new-10.jpeg";
import familyNew11 from "@/assets/family-new-11.jpeg";
import familyNew12 from "@/assets/family-new-12.jpeg";
import familyNew13 from "@/assets/family-new-13.jpeg";
import familyNew14 from "@/assets/family-new-14.jpeg";
import familyNew15 from "@/assets/family-new-15.jpeg";
import familyNew16 from "@/assets/family-new-16.jpeg";
import familyNew17 from "@/assets/family-new-17.jpeg";
import { useLanguage } from "@/i18n/LanguageContext";
import { useRoomContent } from "@/hooks/useRoomContent";

const FamilyRoom = () => {
  const { t } = useLanguage();
  const { current } = useRoomContent("family");
  const rd = t.roomData;
  const images = [
    { src: familyNew1, alt: current?.title || t.subpageHeroes.familyRoom.title },
    { src: familyNew2, alt: "Zimmer mit Balkon & TV" },
    { src: familyNew3, alt: "Schrank, Sofabett & Bad" },
    { src: familyNew4, alt: "Balkon & Bad" },
    { src: familyNew5, alt: "Schreibtisch & TV" },
    { src: familyNew15, alt: "Zimmerübersicht" },
    { src: familyNew10, alt: "Dachzimmer" },
    { src: familyNew11, alt: "Doppelbett Detail" },
    { src: familyNew12, alt: "Einzelbett Detail" },
    { src: familyNew13, alt: "Schreibtisch & Mikrowelle" },
    { src: familyNew14, alt: "TV & Badezimmer" },
    { src: familyNew6, alt: "Sofabett" },
    { src: familyNew7, alt: "Badezimmer" },
    { src: familyNew8, alt: "Badezimmer 2" },
    { src: familyNew9, alt: "Schrank" },
    { src: familyNew16, alt: "Balkon" },
    { src: familyNew17, alt: "Waschbecken & Spiegel" },
  ];
  const amenityLabels = current?.amenities?.length ? current.amenities : rd.family.amenities;
  const amenities = amenityLabels.map((label, i) => ({
    icon: [Bed, Bath, Tv, Wifi, Car][i],
    label,
  }));
  return (
    <RoomDetail
      title={current?.title || t.subpageHeroes.familyRoom.title}
      subtitle={current?.description || t.subpageHeroes.familyRoom.subtitle}
      images={images}
      amenities={amenities}
      features={rd.features}
      highlight={{ image: familyNew2, title: current?.highlight || rd.family.highlight, subtitle: current?.highlightSub || rd.family.highlightSub }}
    />
  );
};

export default FamilyRoom;
